module.exports = __webpack_public_path__ + "static/media/lets_look_at_your_results_bear.333b58cd.png";